import { get } from "./base";

export async function getRegisterInfo() {
    let respObj = await get("/edu-classroom/platformconf/getlogindictlistbytype");
    if (respObj != false) {
        let result = {
            area: [{title: '请选择区市', id: 0}],
            period: [{title: '请选择学段', id: 0}],
            subject: [{title: '请选择学科', id: 0}],
            hillock:[],
        };
        // 区域
        for (const obj of respObj.sys_area) {
            for (const item of obj.dictDataVoList) {
                result.area.push({title: item.dictLabel, id: item.dictValue});
            }
        }
        // 学段
        for (const obj of respObj.classroom_period) {
            for (const item of obj.dictDataVoList) {
                result.period.push({title: item.dictLabel, id: item.dictCode});
            }
        }
        // 学科
        for (const obj of respObj.classroom_subject) {
            for (const item of obj.dictDataVoList) {
                result.subject.push({title: item.dictLabel, id: item.dictCode});
            }
        }
        // 岗层
        for (const obj of respObj.classroom_hillock) {
            for (const item of obj.dictDataVoList) {
                result.hillock.push({title: item.dictLabel, id: item.dictCode});
            }
        }
        return result;
    }
    return {}
}
